// initial state
const state = {
  splitOptions: {
    invoiceStatus: {
      1: '待开票',
      2: '开票中',
      3: '已开票',
      4: '待作废',
      5: '作废中',
      6: '已作废',
    },
  },
  options: {
    status: [
      {label: '待审批', value: 1},
      {label: '已放弃', value: 4},
      {label: '已驳回', value: 3, color: '#F56C6C'},
      {label: '待开票', value: 2},
      {label: '开票中', value: 5},
      {label: '已开票(未同步金蝶)', value: 15},
      {label: '已开票', value: 6},
      {label: '已签收', value: 7, color: '#67C23A'},
      {label: '待作废', value: 8},
      {label: '作废中', value: 13},
      {label: '已作废(未同步金蝶)', value: 16, color: '#F56C6C'},
      {label: '已作废', value: 9, color: '#F56C6C'},
      {label: '已开红冲', value: 10, color: '#F56C6C'},
      {label: '红冲开具中', value: 14, color: '#F56C6C'},
      {label: '红冲发票(未同步金蝶)', value: 17, color: '#F56C6C'},
      {label: '红冲发票', value: 11, color: '#F56C6C'},
    ],
    issued_type: [
      {label: '常规开票', value: '1'},
      {label: '预收款开票', value: '2'},
    ],
    // 预收款开票信息的抵扣状态
    deduction_status: [
      {label: '未抵扣', value: 1},
      {label: '待审批', value: 2},
      {label: '待抵扣', value: 3},
      {label: '部分抵扣', value: 4},
      {label: '已抵扣', value: 5},
    ],
    // 预收款开票抵扣信息条目状态,bu审批通过为待抵扣,财务通过为抵扣完成,驳回直接失败
    deduction_detail_status: [
      {label: '待审批', value: 1},
      {label: '待抵扣', value: 2},
      {label: '抵扣完成', value: 3, color: '#04D919'},
      {label: '抵扣失败', value: 4, color: '#D9001B'},
      {label: '已放弃', value: 5},
    ],
    type: [
      {label: '增值税专用发票', value: 1},
      {label: '增值税普通发票', value: 2},
      {label: '形式发票', value: 3},
      {label: '电子发票（增值税专用发票）', value: 4},
      {label: '电子发票（普通发票）', value: 5},
    ],
    subject: [
      {label: '小零', value: 1},
      {label: '数饮', value: 2},
      {label: '零启', value: 3},
    ],
    currency_type: [
      {label: '人民币', value: 1, symbol: '￥'},
      {label: '美元', value: 2, symbol: '$'},
      {label: '欧元', value: 3, symbol: '€'},
    ],
    cost_type: [
      {label: '现代服务*服务费', value: 1},
      {label: '现代服务*技术服务费', value: 7},
      {label: '现代服务*市场调研费', value: 8},
      {label: '现代服务*咨询服务费', value: 3},
      {label: '现代服务*营销服务费', value: 4},
      {label: '现代服务*推广策划服务费', value: 5},
      {label: '现代服务*其他现代服务费', value: 2},
      {label: '经纪代理服务*酬金', value: 6},
      {label: '会展服务*服务费', value: 9},
      {label: '设计服务*电商物料设计', value: 10},
      {label: '信息技术服务*软件开发服务', value: 12},
      {label: '信息技术服务*软件维护服务', value: 13},
      {label: '信息技术服务*软件测试服务', value: 14},
      {label: '信息技术服务*信息系统服务', value: 15},
      {label: '信息技术服务*信息系统增值服务', value: 16},
      {label: '其他咨询服务*技术咨询', value: 17},
      {label: '信息技术服务*业务流程管理服务', value: 18},
      {label: '会展服务*会议服务', value: 19},
      {label: '其他咨询服务*咨询服务', value: 20},
      {label: '企业管理服务*其他企业管理服务', value: 21},
      {label: '现代服务*市场推广', value: 22},
      {label: '设计服务*专业设计服务', value: 23},
      {label: '广告服务*广告代理服务', value: 24},
      {label: '其他技术类开票', value: 25},
      {label: '其他', value: 11},
    ],
    tax_type: [
      // {label: '无', value: 0},
      {label: '含税金额', value: 1},
      {label: '未税金额', value: 2},
    ],
    received_payment_status: [
      {label: '待回款', value: 0},
      {label: '部分回款', value: 1},
      {label: '已回款', value: 2},
    ]
  },
  receipt_export_headers: [
    {
      key: 'subject_name',
      text: '开票主体',
    },
    {
      key: 'id',
      text: '开票申请ID',
    },
    {
      key: 'issued_type',
      text: '开票类别',
    },
    {
      key: 'invoice_full_name',
      text: '开票名称',
    },
    {
      key: 'product_num',
      text: '商品编码',
    },
    {
      key: 'type',
      text: '发票类别',
    },
    {
      key: 'receipt_info_id',
      text: '开票抬头ID',
    },
    { key: 'invoice_tax_type_cn', text: '开票金额依据' },
    { key: 'buyer_company_name', text: '购买方名称' },
    { key: 'buyer_tax_number', text: '购买方纳税人识别号' },
    { key: 'invoice_remark', text: '发票备注' },
    {
      key: 'pay_condition_name',
      text: '账期',
    },
    {
      key: 'project_number',
      text: '项目编号',
    },
    {
      key: 'project_name',
      text: '项目名称',
    },
    {
      key: 'bu_name',
      text: 'BO审批',
    },
    {
      key: 'initiator_name',
      text: '发起人',
    },
    {
      key: 'invoice_time',
      text: '开票日期',
    },
    { key: 'unit', text: '单位' },
    { key: 'quantity', text: '数量' },
    {
      key: 'total',
      text: '含税金额',
    },
    { key: 'tax_rate', text: '税率' },
    {
      key: 'untaxed_amount',
      text: '未税金额',
    },
    {
      key: 'tax',
      text: '税额',
    },
    {
      key: 'invoice_number',
      text: '发票号码',
    },
    {
      key: 'status',
      text: '开票状态',
    },
    {
      key: 'customer_name',
      text: '客户名称',
    },
    {
      key: 'customer_number',
      text: '客户编号',
    },
    {
      key: 'desc',
      text: '申请描述',
    },
    {
      key: 'do_number',
      text: 'DO/PO单号',
    },
    {
      key: 'memo',
      text: '开票备注',
    },
    {
      key: 'created_at',
      text: '添加日期',
    },
    {
      key: 'updated_at',
      text: '更新日期',
    },
    {
      key: 'finance_name',
      text: '财务审批人',
    },
  ],
  pre_receipt_export_headers: [
    {
      key: 'id',
      text: '开票申请ID',
    },
    {
      key: 'subject',
      text: '开票主体',
    },
    {
      key: 'customer_number',
      text: '客户编号',
    },
    {
      key: 'customer_name',
      text: '客户名称',
    },
    { key: 'buyer_company_name', text: '购买方名称' },
    { key: 'buyer_tax_number', text: '购买方纳税人识别号' },
    { key: 'invoice_remark', text: '发票备注' },
    {
      key: 'bd_name',
      text: 'BD',
    },
    {
      key: 'bu_name',
      text: 'BO审批',
    },
    {
      key: 'initiator_name',
      text: '发起人',
    },
    {
      key: 'virtual_project_number',
      text: '预收款项目编号',
    },
    { key: 'unit', text: '单位' },
    { key: 'quantity', text: '数量' },
    {
      key: 'total',
      text: '含税开票金额',
    },
    { key: 'tax_rate', text: '税率' },
    {
      key: 'received_amount',
      text: '回款金额',
    },
    {
      key: 'project_number',
      text: '抵扣项目编号',
    },
    {
      key: 'deduction_amount',
      text: '抵扣含税开票金额',
    },
    {
      key: 'available_deduct_amount',
      text: '未抵扣含税金额',
    },
    {
      key: 'deduction_status',
      text: '抵扣状态',
    },
    {
      key: 'deduction_detail_updated_at',
      text: '抵扣时间',
    },
    {
      key: 'invoice_number',
      text: '发票号',
    },
    {
      key: 'invoice_time',
      text: '开票时间',
    },
    {
      key: 'received_payment_time',
      text: '回款时间',
    },
  ],
  uncollection_export_header: [
    {
      key: 'receipt_apply_id',
      text: '开票申请ID',
    },
    {
      key: 'subject_name',
      text: '开票主体',
    },
    {
      key: 'customer_name',
      text: '客户名称',
    },
    {
      key: 'customer_number',
      text: '客户编号',
    },
    {
      key: 'receipt_info_id',
      text: '开票抬头ID',
    },
    {
      key: 'receipt_info_company_name',
      text: '公司名称',
    },
    {
      key: 'pay_condition_name',
      text: '账期',
    },
    {
      key: 'project_name',
      text: '项目名称',
    },
    {
      key: 'project_number',
      text: '项目编号',
    },
    {
      key: 'bu_name',
      text: 'BO审批',
    },
    {
      key: 'initiator_name',
      text: '发起人',
    },
    {
      key: 'invoice_date',
      text: '开票日期',
    },
    {
      key: 'invoice_number',
      text: '发票号码',
    },
    {
      key: 'remains_received_amount',
      text: '未回款金额',
    },
    {
      key: 'issued_type_name',
      text: '开票类别',
    },
    {
      key: 'export_time',
      text: '导出时间',
    },
  ],
  collection_export_header: [
    {
      key: 'receipt_apply_id',
      text: '开票申请ID',
    },
    {
      key: 'collection_id',
      text: '回款ID',
    },
    {
      key: 'subject_name',
      text: '开票主体',
    },
    {
      key: 'customer_name',
      text: '客户名称',
    },
    {
      key: 'customer_number',
      text: '客户编号',
    },
    {
      key: 'receipt_info_id',
      text: '开票抬头ID',
    },
    {
      key: 'receipt_info_company_name',
      text: '公司名称',
    },
    {
      key: 'pay_condition_name',
      text: '账期',
    },
    {
      key: 'project_name',
      text: '项目名称',
    },
    {
      key: 'project_number',
      text: '项目编号',
    },
    {
      key: 'bu_name',
      text: 'BO审批',
    },
    {
      key: 'initiator_name',
      text: '发起人',
    },
    {
      key: 'invoice_date',
      text: '开票日期',
    },
    {
      key: 'invoice_number',
      text: '发票号码',
    },
    {
      key: 'collection_amount',
      text: '回款金额',
    },
    {
      key: 'collection_date',
      text: '回款日期',
    },
    {
      key: 'collection_bank',
      text: '收款账户',
    },
    {
      key: 'export_time',
      text: '导出时间',
    },
  ]
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const invoiceApply = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/invoice-apply/invoice-apply.store.js